// Import Bootstrap (optional: only the parts you need)
import 'bootstrap';
import '../scss/app.scss';

